// extracted by mini-css-extract-plugin
export default {"weblinks":"WebLinks_weblinks__gikeP","headline":"WebLinks_headline__541WV","input":"WebLinks_input__4tXtZ","img":"WebLinks_img__9MTcF"};